import React from 'react';
import { HeaderBar } from './HeaderBar';
import { HeaderNav } from './HeaderNav';

import './_layout.scss';

export const Header: React.FC = () => (
  <>
    <HeaderBar />
    <HeaderNav />
  </>
);
